import { useMemo } from 'react';
import type { EmployeeWithSchedule, WeekType } from '@functieloonhuis/shared';
import { getDayEntryForDay } from '../utils/weekUtils';

interface ScheduleStatsProps {
  employees: EmployeeWithSchedule[];
  selectedWeek: WeekType;
}

export function ScheduleStats({ employees, selectedWeek }: ScheduleStatsProps) {
  const stats = useMemo(() => {
    // Get today's ISO day (1=Monday, 7=Sunday)
    const jsDay = new Date().getDay();
    const today = jsDay === 0 ? 7 : jsDay;

    let kantoor = 0;
    let thuis = 0;
    let vrij = 0;

    for (const emp of employees) {
      const entries = selectedWeek === 'A' ? emp.weekA : emp.weekB;
      const entry = getDayEntryForDay(entries, today);

      if (entry?.isWorkday) {
        if (entry.location === 'kantoor') kantoor++;
        else if (entry.location === 'thuis') thuis++;
      } else {
        vrij++;
      }
    }

    return { kantoor, thuis, vrij, total: employees.length };
  }, [employees, selectedWeek]);

  if (stats.total === 0) return null;

  return (
    <div className="grid grid-cols-3 gap-4">
      <div className="bg-green-50 p-3 rounded-lg border border-green-200 text-center">
        <p className="text-2xl font-bold text-green-700">{stats.kantoor}</p>
        <p className="text-xs text-green-600">Op kantoor vandaag</p>
      </div>
      <div className="bg-blue-50 p-3 rounded-lg border border-blue-200 text-center">
        <p className="text-2xl font-bold text-blue-700">{stats.thuis}</p>
        <p className="text-xs text-blue-600">Thuis vandaag</p>
      </div>
      <div className="bg-gray-50 p-3 rounded-lg border border-gray-200 text-center">
        <p className="text-2xl font-bold text-gray-700">{stats.vrij}</p>
        <p className="text-xs text-gray-500">Vrij vandaag</p>
      </div>
    </div>
  );
}
